<script>
import roundMatch from './CompetitionRoundMatch.vue';
import roundPool from './CompetitionRoundPool.vue';

export default {
  name: 'round',

  data() {
    return {
      matches: [],
      pools: [],
      isLoading: true,
    }
  },

  props: [
    'rounds',
    'round',
    'competition',
    'results',
  ],

  components: {
    roundMatch,
    roundPool,
  },

  template: `
    <div class="competition-round">
      <div class="round-title">
        <div class="round-heading">{{ round.title }}</div>
        <div class="round-date" v-if="round.date">
          <span v-if="competition && competition.competition_type == 'round robin'">Starting&nbsp;</span>{{ round.date | formatDate }}
        </div>
      </div>

      <div class="round-matches">
        <div v-if="round.notes" class="round-note">{{ round.notes }}</div>
        
        <round-match
            v-for="match in matches"
            v-bind:key="match.key"
            v-bind:competition-id="competition.id"
            v-bind:competition_type="competition.competition_type"
            v-bind:rounds="rounds"
            v-bind:round="round"
            v-bind:results="results"
            v-bind:match="match"
            v-bind:applications="competition.applications"
            v-bind:delegated_progression="competition.delegated_progression"
            class="round-match">
        </round-match>

        <round-pool
            v-for="pool in pools"
            v-bind:key="pool.key"
            v-bind:competition-id="competition.id"
            v-bind:competition_type="competition.competition_type"
            v-bind:rounds="rounds"
            v-bind:round="round"
            v-bind:results="results"
            v-bind:pool="pool"
            class="round-pool">
        </round-pool>
      </div>
    </div>
  `,

  mounted() {
    this.matches = this.round.matches;
    this.pools = this.round.pools;
  },
}
</script>

<style scoped>
</style>
